module.exports = __webpack_public_path__ + "static/media/agent101.41a8c680.png";